import { Box, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import useMedia from '../../hooks/useMedia';
import Config from '../../config';

const InformPasswordResetModal = observer(
  ({ open, onClose }: { open: boolean; onClose: () => void }): JSX.Element => {
    const configuration = Config[process.env.REACT_APP_CLIENT || 'wbg'];
    const isMobile = useMedia('md');

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle color="secondary">
          Information der {configuration.name}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              paddingX: isMobile ? 0 : 10,
            }}
          >
            <Typography sx={{ my: 4 }}>
              Bitte prüfen Sie, ob die eingegebene Email-Adresse mit ihrem
              Account übereinstimmt.
              <br />
              <br />
              Sollten weiterhin Probleme bestehen, können Sie Ihr Passwort
              zurückzusetzen oder melden Sie sich direkt bei ihrem zuständigen
              Hausverwalter.
            </Typography>
            <Link to="/passwort-link-anfordern">
              <Typography
                sx={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: 'grey',
                  textDecoration: 'underline',
                }}
                variant="subtitle1"
              >
                Passwort zurücksetzen
              </Typography>
            </Link>
          </Box>
        </DialogContent>
      </Dialog>
    );
  },
);

export default InformPasswordResetModal;
